import React from "react";
import { DrawerComponent, Box } from "@InnoUI";
import { useSelector } from "react-redux";

const Drawer = ({ drawerItems = [] }) => {
  const authData = useSelector((state) => state.authdata);

  const filteredRoutes = drawerItems;

  return (
    <Box>
      <DrawerComponent navItems={filteredRoutes} />
    </Box>
  );
};

export default Drawer;
